<template>
  <div>
    <HeaderCheckout />
    <Breadcrumbs title="Checkout" />
    <section class="cart-section section-b-space">
      <div v-if="pending_delivery === 1" class="delivery_status"><router-link :to="{ path: '/delivery_map'}">Delivery In Progress</router-link></div>


      <template v-if="special_banner_url">
        <div v-if="special_banner_text" class="special_banner"><a style="color:white;" v-bind:href=special_banner_url target="_blank" @click="href_click_log('checkout_banner')">{{special_banner_text}}</a></div>
      </template>
      <template v-else>
        <div v-if="special_banner_text" class="special_banner">{{special_banner_text}}</div>
      </template>


      <div class="container">
        <div class="checkout-page mt-3">


          <!--&lt;!&ndash;          This part CANT be within /FORM, it crashes!!&ndash;&gt;-->
<!--        <template v-if="is_pickup">-->
<!--          <template v-if="is_drive_trough">-->
<!--          </template>-->
<!--          <template v-else>-->
<!--            <button @click="switchToDelivery()" class="btn-solid btn">Deliver to me.</button>-->
<!--          </template>-->
<!--        </template>-->
<!--        <template v-else>-->
<!--          <button @click="switchToPickup()" class="btn-solid btn">I like to pickup the order.</button>-->
<!--          <p></p>-->
<!--        </template>-->

<!--          <template v-if="is_pickup">-->
<!--            <template v-if="is_drive_trough">-->
<!--            </template>-->
<!--            <template>-->
<!--              <button @click="switchToDelivery()" class="btn-solid btn">Deliver to me.</button>-->
<!--            </template>-->
<!--          </template>-->
<!--          <template v-else>-->
<!--            <button @click="switchToPickup()" class="btn-solid btn">I like to pickup the order.</button>-->
<!--            <p></p>-->
<!--          </template>-->
          <div class="checkout-form">
            <form>
              <div class="row">
                <div class="col-lg-12 col-sm-12 col-xs-12">
                  <div class="row check-out">
                    <template v-if="is_pickup">
                    </template>
                    <template v-else>
                      <Map />
                    </template>

<!--                    <div class="form-group col-md-12 col-sm-12 col-xs-12 mt-3">-->
<!--                      <div class="field-label">Special instructions</div>-->
<!--                      <input type="text" required v-model="special_instructions_message" name="field-name" placeholder="Enter Special instructions"/>-->
<!--                    </div>-->
<!--                    NO set 'required' reload some kind of checks local!-->
                  </div>
                </div>

                <div class="form-group col-md-12 col-sm-12 col-xs-12 mt-3">
                  <div class="field-label">Promo Code</div>
                  <input type="text" required v-model="overall_promo_coupon" name="field-name" placeholder="Promo Code"/>
                  <button @click="update_overall_promo_code()" class="btn-solid btn" v-if="show_overall_promo_coupon_button">Apply Promo Code</button>
                </div>

                <div class="col-lg-12 col-sm-12 col-xs-12">
                  <div class="checkout-details">
                    <div class="order-box">

<!--                      <div v-if="delivery_address.length" class="title-box">-->
<!--                        <div v-if="is_pickup">-->
<!--                          PICKUP ADDRESS-->
<!--                        </div>-->
<!--                        <div v-else>-->
<!--                          DELIVERY ADDRESS-->
<!--                        </div>-->
<!--                      </div>-->

                      <template v-if="!is_drive_trough">
<!--                      <ul class="qty" v-if="is_pickup">-->
<!--                        <li>-->
<!--                          <div class="row">-->
<!--                            <div class="col-12">{{pickup_address.company}}</div>-->
<!--                            <div class="col-12">{{pickup_address.address}}</div>-->
<!--                            <div class="col-12">{{pickup_address.city}}, {{pickup_address.state}} {{pickup_address.zip}} </div>-->
<!--                            <div class="col-12">{{pickup_address.phone}}</div>-->
<!--                          </div>-->
<!--                        </li>-->
<!--                      </ul>-->
<!--                      <ul class="qty"  v-else>-->
<!--
                        <ul>
                          <li>
                            <div class="row">
                              <div class="col-12">{{ full_name }}</div>
                              <div class="col-12">{{ street_number }} {{street_name}}</div>
                              <div class="col-12">{{city_name}}, {{state_name_short}} {{postal_code}}</div>
                            </div>
                          </li>
                        </ul>
                        <br>
                        -->
                      </template>

                      <ul class="qty"  v-if="cart.length">
                        <li v-for="(item,index) in cart" :key="index">
                          <div class="row">
                            <div class="col-3">
                                <img
                                  :src='item.image_url_small'
                                  class="rrr-img checkout_img"
                                  :alt="item.desc"
                                />
                            </div>
                            <div class="col-9 d-flex align-items-center justify-content-between">
                              <span>Qty: {{item.qty}} &nbsp; &#xd7; &nbsp; {{item.single_price_show_incl_tax}}</span>


                              <div class="row" v-if="item.discount_code">
                                <span class="col-8">{{item.discount_code}} {{item.discount_qty_amount_show_incl_tax}}</span>
                              </div>

                              <div v-if="item.isrewarditem === 1">
                                <template v-if="item.rewarditemtext">
                                  <span class="col-8">{{item.rewarditemtext}}</span>
                                </template>
                                <temlate v-else>
                                  <span class="col-8">Your Unibud Reward</span>
                                </temlate>
                              </div>

                              <h6>{{item.discounted_qty_price_show_incl_tax}}</h6>


                            </div>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div class="checkout-sub-total" v-if="cart.length">
                    <table class="sub-total" align="center">
                      <tfoot>
                          <tr v-for="tax in webTotalLines" :key="tax.text" >
                            <td style="outline:none;" v-if="tax.type=='taxesfees'" v-b-modal.modal-check-detail>{{tax.text}}</td>
                            <td v-else>{{tax.text}}</td>
                            <td class="col-right">
                              <div :style="tax.style=='crossed'?'text-decoration: line-through;':tax.style=='bold'?'font-weight: bold;':'font-style: normal;'">{{tax.value_show}}</div>
                            </td>
                          </tr>
                      </tfoot>
                    </table>
                  </div>

                    <div class="payment-box">
                      <div class="upper-box">
                        <div class="payment-options">
                          <ul class="custom-radio">
                            <li>
                              <div class="radio-option">
                                <input
                                  type="radio"
                                  name="payment-group"
                                  id="payment-1"
                                  v-model.number="pt"
                                  value="1"
                                  v-on:change="changePayment"
                                />
                                <label for="payment-1">
                                  Debit Card, 4 digit PIN required
                                </label>
                                <label class="swipe-card">We'll Need To swipe Your Card Upon Delivery</label>
                              </div>
                            </li>
                            <li>
                              <div class="radio-option paypal">
                                <input
                                  type="radio"
                                  name="payment-group"
                                  id="payment-3"
                                  v-model.number="pt"
                                  value="2"
                                  v-on:change="changePayment"
                                />
                                <label for="payment-3">
                                  Cash
                                </label>
                              </div>
                            </li>
                          </ul>
                        </div>
                        <div>
                        <template v-if="signedIn">
                          <template v-if="license_management.temp_sale_allowed === 1">

                            <template v-if="storeIsOpen">
                              <div class="text-right">
                                <div v-if="!getBlockCheckout && cart.length">
                                  <a @click="order()" v-if="!delivery_address.length && !is_pickup" v-b-modal.address-issue class="btn-solid btn checkout-btn sign-checkout-btn">Place Order</a>
                                  <a @click="order()" v-else class="btn-solid btn checkout-btn sign-checkout-btn">Place Order</a>
                                </div>
                                <router-link v-else :to="{ path: '/shop/'}">
                                  <a class="btn-solid btn checkout-btn sign-checkout-btn">Shop</a>
                                </router-link>
                              </div>
                            </template>
                            <template v-else>
                              <div class="text-right">
<!--                                      <router-link :to="{ path: '/openinghours'}">-->
<!--                                        <a class="btn-solid btn">Store is Closed</a>-->
<!--                                      </router-link>-->
                                <h3>Delivery not available right now.</h3>
                              </div>
                            </template>

                          </template>
                          <template v-else>
                            <div class="text-right">
                              <router-link :to="{ path: '/account/upload_docs'}">
                                <a class="btn-solid btn checkout-btn sign-checkout-btn">Please upload your driver license</a>
                              </router-link>
                            </div>
                          </template>
                      </template>
                      <template v-else>
                        <div class="text-right">
                          <router-link :to="{ path: '/login'}">
                            <a class="btn btn-solid checkout-btn sign-checkout-btn">Sign In To Continue</a>
                          </router-link>
                        </div>
                      </template>
                        </div>
                      </div>
                      <div class="text-left">
                        {{getWarningText}}
                        <template v-if="getFreeDeliveryText">
                        <br>
                        {{getFreeDeliveryText}}
                        </template>
                      </div>
                    </div>

                  Our Hours of Delivery are 4pm - 10pm

                </div>
              </div>
            </form>
          </div>
        </div>
      </div>






      <b-modal id="modal-check-detail" size="lg" centered :hide-footer="true">
        <div class="tax-fee-title">{{webTotalTitle}}</div>
        <table style="border-spacing:15px;" align="center">
          <thead>
            <tr>
              <td class="tax-fee-header">DETAIL</td>
              <td class="tax-fee-header">DESCRIPTION</td>
              <td class="tax-fee-header">PRICE</td>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(fee,index) in webTotalDetails" :key="index">
              <td>{{fee.text}}</td>
              <td class="tf-margin">{{fee.description}}</td>
              <td>{{fee.value_show}}</td>
            </tr>
          </tbody>
        </table>
      </b-modal>

    <b-modal id="address-issue" size="md" centered hide-header hide-footer v-if="!is_pickup" class="address-issue">
      <div class="text-center">
        <h2>Please Enter <br> Delivery Address</h2>
        <b-button class="mt-3 close-address-btn" block @click="$bvModal.hide('address-issue')">Close</b-button>
      </div>
    </b-modal>

    </section>
    <Footer />
  </div>
</template>
<script>

import { mapGetters } from 'vuex'
import HeaderCheckout from '@/components/header'
import Footer from '@/components/footer'
import Breadcrumbs from '@/components/widgets/cart-breadcrumbs'
import Map from '@/components/map'


export default {
  components: {
    HeaderCheckout,
    Footer,
    Breadcrumbs,
    Map
  },
  computed: {
    ...mapGetters({
      signedIn: 'auth/signedIn',
      storeIsOpen: 'auth/storeIsOpen',
      cart: 'cart/cartItems',
      overallPromoCoupon: 'cart/getOverallPromoCoupon',
      webTotalDetails: 'cart/webTotalDetails',
      webTotalLines:'cart/webTotalLines',
      paymenttype:'cart/paymenttype',
      is_pickup:'cart/is_pickup',
      is_drive_trough:'cart/is_drive_trough',
      pickup_address:'cart/pickup_address',
      webTotalTitle: 'cart/webTotalTitle',
      delivery_address: 'cart/getDeliveryAddress',
      full_name: 'auth/getFullName',
      getBlockCheckout: 'cart/getBlockCheckout',
      getFreeDeliveryText: 'cart/getFreeDeliveryText',
      getIsFreeDelivery: 'cart/getIsFreeDelivery',
      getWarningText: 'cart/getWarningText',
      license_management: 'auth/getLicenseManagement',
      getAccessToken: 'auth/getAccessToken',
      getLoaded: 'products/getLoaded',
      cart_is_signed_in: 'cart/cart_is_signed_in',
      pending_delivery: 'auth/pending_delivery',
      special_banner_text: 'cart/special_banner_text',
      special_banner_url: 'cart/special_banner_url',
    }),
    city_name: function () {
      let answer  = '';
      if(this.delivery_address.length > 0) {
        this.delivery_address.forEach(function (item) {
          if(item.types.includes("neighborhood")) {
            answer = item.long_name;
          }
        });
        if (answer === '') {
          this.delivery_address.forEach(function (item) {
            if(item.types.includes("locality")) {
              answer = item.long_name;
            }
          });
        }
      }
      return answer;
    },
    postal_code: function () {
      let answer  = '';
      if(this.delivery_address.length > 0) {
        this.delivery_address.forEach(function (item) {
          if(item.types.includes("postal_code")) {
            answer = item.long_name;
          }
        });
      }
      return answer;
    },
    state_name_short: function () {
      let answer  = '';
      if(this.delivery_address.length > 0) {
        this.delivery_address.forEach(function (item) {
          if (item.types.includes("administrative_area_level_1")) {
            answer = item.short_name;
          }
        });
      }
      return answer;
    },
    street_name: function () {
      let answer  = '';
      if(this.delivery_address.length > 0) {
        this.delivery_address.forEach(function (item) {
          if (item.types.includes("route")) {
            answer = item.short_name;
          }
        });
      }
      return answer;
    },
    street_number: function () {
      let answer  = '';
      if(this.delivery_address.length > 0) {
        this.delivery_address.forEach(function (item) {
          if (item.types.includes("street_number")) {
            answer = item.short_name;
          }
        });
      }
      return answer;
    },
  },
  mounted() {

    if(!this.getLoaded) {
      this.$router.push({name: 'home'})
    }

    this.overall_promo_coupon = this.overallPromoCoupon;

    this.pt=this.paymenttype;
    if(this.signedIn) {
      this.$store.dispatch('auth/getDLMCData');
      this.$store.dispatch('auth/getAccount', {register_it: 0})
      if(this.cart_is_signed_in === 0) {
        this.$store.dispatch('cart/loadShoppingCart');
      }
      this.$store.dispatch('auth/getPendingDeliveryStatus');
    }
  },
  data() {
    return {
      result_debit: null,
      special_instructions_message: '',
      overall_promo_coupon: '',
      show_overall_promo_coupon_button: false,
      pt: 0,
      user: {
        address: '',
        city: '',
        state: '',
        zipcode: ''
      },
      isLogin: false,
      amtchar: ''
    }
  },
  watch: {
    overallPromoCoupon: async function () {
      this.overall_promo_coupon = this.overallPromoCoupon;
    },
    overall_promo_coupon: async function() {

      if (this.overallPromoCoupon === this.overall_promo_coupon.toUpperCase()) {
        this.show_overall_promo_coupon_button = false;
      } else {
        this.show_overall_promo_coupon_button = true;
      }
      if (!this.overall_promo_coupon) {
        this.show_overall_promo_coupon_button = false;
      }
    },
  },
  methods: {
    href_click_log(type) {
      this.$store.dispatch('auth/setHrefClickLog',{type: type, 'url': this.special_banner_url });
    },
    update_overall_promo_code() {
      this.$store.dispatch('cart/setOverallPromoCode',{promocoupon: this.overall_promo_coupon})
      this.show_overall_promo_coupon_button = false;
      this.overall_promo_coupon = "";
    },
    changePayment(val){
      this.$store.dispatch('cart/paymentSelect',{payment_type:+val.target.value})
      // this.pt=this.paymenttype
    },
    order() {
      if((this.delivery_address.length > 0) || (this.is_pickup)) {
        this.$router.push('/shop/order-success')
        this.$store.dispatch('cart/order',{
          special_instructions_message:this.special_instructions_message,
          is_pickup: this.is_pickup,
          is_drive_trough: this.is_drive_trough,
        })
      }
    },
    // switchToDelivery() {
    //   this.$store.dispatch('cart/setPickupDelivery',{is_pickup: 0})
    // },
    // switchToPickup() {
    //   this.$store.dispatch('cart/setPickupDelivery',{is_pickup: 1})
    // },
  }
}
</script>
